/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../../../types/graph';

import * as Operations from './query.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type NavigatorQueryVariables = SchemaTypes.Exact<{
  uuid: SchemaTypes.Scalars['ID']['input'];
  lifeApplicationId: SchemaTypes.Scalars['ID']['input'];
}>;


export type NavigatorQuery = { __typename?: 'Query', customer: { __typename?: 'Customer', id: string, userAttributes: string, identityProfile: { __typename?: 'IdentityProfile', id: string, email: string | null, firstName: string | null } } | null, lifeApplication: { __typename?: 'LifeApplication', id: string, policies: { __typename?: 'LifeApplicationPolicies', appliedPolicy: { __typename?: 'LifeApplicationPolicy', id: string, policyNumber: string | null, issueType: string | null, carrier: { __typename?: 'LifeInsuranceCarrierType', id: string, slug: string } | null } | null } } };


export function useNavigatorQuery(baseOptions: Apollo.QueryHookOptions<NavigatorQuery, NavigatorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavigatorQuery, NavigatorQueryVariables>(Operations.Navigator, options);
      }
export function useNavigatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavigatorQuery, NavigatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavigatorQuery, NavigatorQueryVariables>(Operations.Navigator, options);
        }
export type NavigatorQueryHookResult = ReturnType<typeof useNavigatorQuery>;
export type NavigatorLazyQueryHookResult = ReturnType<typeof useNavigatorLazyQuery>;